// Este código é opcional e é usado para registar um service worker.
// register() não é chamado por defeito.

// Isto permite que a aplicação carregue mais rapidamente em visitas subsequentes em produção e
// dá-lhe capacidades offline. No entanto, também significa que os programadores (e utilizadores)
// só verão as atualizações implementadas em visitas subsequentes a uma página, depois de todos os
// separadores existentes abertos na página terem sido fechados, uma vez que os recursos previamente
// em cache são atualizados em segundo plano.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] é o endereço IPv6 do localhost.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 são considerados localhost para IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  // --- CORREÇÃO APLICADA ---
  // Alterado para registar o Service Worker em desenvolvimento (localhost) também,
  // o que é essencial para testar as notificações push.
  if ('serviceWorker' in navigator) {
    // O construtor de URL está disponível em todos os navegadores que suportam SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // O nosso service worker não funcionará se PUBLIC_URL estiver num domínio diferente
      // daquele em que a nossa página é servida.
      return;
    }

    window.addEventListener('load', () => {
      // --- CORREÇÃO APLICADA ---
      // Aponta diretamente para o service worker do Firebase Messaging.
      const swUrl = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`;

      if (isLocalhost) {
        // Em localhost, regista diretamente o nosso service worker.
        registerValidSW(swUrl, config);

        navigator.serviceWorker.ready.then(() => {
          // A linha abaixo foi comentada para limpar o console de desenvolvimento.
          // console.log('Firebase Messaging service worker registered successfully on localhost.');
        });
      } else {
        // Em produção, regista o service worker.
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log(
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://cra.link/PWA.'
              );

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log('Content is cached for offline use.');

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

// A função checkValidServiceWorker foi removida por ser desnecessária para este caso de uso específico.

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}